import { useContentType } from '@confluence/page-context';
import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode';
import { useContentClassification } from '../hooks/useContentClassification';
import { useIsDataClassificationEnabledForOrg } from '@confluence/data-classification';
import { PageMode } from '@confluence/page-utils/entry-points/enums';
import { ContentType } from '@confluence/content-types-utils';

/**
 * Determines if the classification row should be displayed. This function is designed
 * to take no arguments, allowing it to be called from './InfoSection' to assess if
 * the section title should be shown. The title is not displayed if no sections are visible.
 */
export const useClassificationVisibility = () => {
	const [contentType] = useContentType();
	const pageMode = useGetPageMode();
	const { data } = useContentClassification();
	const { isEnabled: isDataClassificationEnabled } = useIsDataClassificationEnabledForOrg();

	const isDataClassificationEmptyOnViewPage = pageMode === PageMode.VIEW && !data.classification;
	const isDataClassificationEnabledForContentType =
		contentType === ContentType.DATABASE || contentType === ContentType.WHITEBOARD;

	return (
		isDataClassificationEnabled &&
		(!isDataClassificationEmptyOnViewPage || isDataClassificationEnabledForContentType)
	);
};
